import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  inputContainer: theme => css`
    margin-top: ${theme.spacing.xs};
    margin-bottom: ${theme.spacing.sm};
  `,
  container: theme => css`
    padding-top: ${theme.spacing.xs};
  `,
})

export default useStyles
